export default {"src":"/_next/static/media/inProgressIcon.23881a7d.svg","height":50,"width":50,"blurWidth":0,"blurHeight":0};